import { app } from "../../config/config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { API, REGION } from "../ref";

const functions = getFunctions(app, REGION);

// ============== //
export const syncInfo = async ({ data }, callback) => {
  try {
    const cloudSyncInfo = httpsCallable(functions, API.ZOHO_SYNC_INFO);

    const response = await cloudSyncInfo(data);

    console.log({ response });

    callback && callback({ status: 200 });
  } catch (err) {
    console.log(err);
    callback && callback({ status: 500, error: err.message });
  }
};
